import styled from "styled-components";

export const WelcomePageWrapper = styled.div`
`;